<template>
  <div ref="mapFooter" class="delivery-map-screen-footer">
    <span class="fs-12 color-slaty"
      >Please wait while we fetch your location</span
    >
    <div class="d-flex justify-content-between mt5">
      <div class="d-flex width50 align-items-start">
        <img
          :src="staticImgBaseUrl + '/images/global/location-icon.svg'"
          alt="location-icon"
        />
        <div class="pl5 width100">
          <div class="hide-shimmer-text shimmer-container rounded width100">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded mt5 width50">
            random tip
          </div>
        </div>
      </div>
      <div
        class="width20 hide-shimmer-text shimmer-container rounded hide-shimmer-text"
        style="height: fit-content"
      >
        button
      </div>
    </div>
    <div class="line-btn secondary w100 mt10 fs-14 fw-800 disable tc mt12">
      Confirm Location
    </div>
  </div>
</template>

<script>
import { staticImgBaseUrl } from "../config/apiEndpoints";
export default {
  name: "MapScreenBottomBarShimmer",
  components: {},
  props: {},
  data() {
    return {
      staticImgBaseUrl,
    };
  },
  mounted() {},
  updated() {},
  methods: {},
  computed: {},
};
</script>

<style></style>
